import { useTranslate } from '@festina-life/ui/hooks'

export const useApprovalStatusTranslations = () => {
  const translate = useTranslate()
  return {
    approved: translate('operationStatus.filter.approved'),
    pending: translate('operationStatus.filter.pending'),
  }
}
